import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";


import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import colorSharp from "../assets/img/color-sharp.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import codeloom from '../assets/img/codeloom.jpeg'
import codecipher from '../assets/img/codecipher.jpeg'

export const UpcommingEvents = () => {

  const projects = [
    {
      title:'CODELOOM',
      description:'hackathon',
      imgUrl:codeloom,
      registrationUrl:'https://copssstc.netlify.app/',
    },
    
    {
      title:'Code Cipher',
      description:'coding contest',
      imgUrl:codecipher,
      registrationUrl:'https://forms.gle/PugVe7EspXAFdxNZ7',
    }
  ];

  return (
    <section className="project" id="UpcomingEvents">
      <img className="background-image-left" src={colorSharp} alt="Image" />

      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>UpcommingEvents</h2>
                  <p>Stay tuned for upcoming coding contests, workshops, and exciting tech events where you can learn, compete, and collaborate with fellow coding enthusiasts.</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">

                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      {/* <Tab.Pane eventKey="first"> */}
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                              />
                            )
                          })
                        }
                      </Row>
                      {/* </Tab.Pane> */}
                      <Tab.Pane eventKey="section">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} />
      {/* <img className="background-image-left" src={colorSharp} alt="Image" /> */}
    </section>
  )
}
